/**
 * This function allows the user to download a file with a specific name by creating a temporary anchor element.
 */
export function downloadFile(url, filename) {
  const a = document.createElement("a");
  a.download = filename;
  a.href = url;
  a.click();
  // Clean up blob URLs to avoid memory leaks
  if (typeof url === "string" && url.startsWith("blob:")) {
    URL.revokeObjectURL(url);
  }
}
